import { useGlobal } from '../../context/GlobalContext';
import { getUiText } from '../../lib/uiText';
import styles from './WhatsAppContactCta.module.css';

export default function WhatsAppContactCta({ id }) {
  const { locale } = useGlobal();
  return <section id={id} className={styles.section}>
    <button type="button" onClick={() => window.dispatchEvent(new Event('whatsapp-form-open'))}>
      {getUiText(locale, 'whatsappHeading')}
    </button>
  </section>;
}
